import { render } from "./PedidosListado.vue?vue&type=template&id=7e15cb58&scoped=true"
import script from "./PedidosListado.vue?vue&type=script&lang=js"
export * from "./PedidosListado.vue?vue&type=script&lang=js"

import "./PedidosListado.vue?vue&type=style&index=0&id=7e15cb58&lang=css"
import "./PedidosListado.vue?vue&type=style&index=1&id=7e15cb58&lang=css"
import "./PedidosListado.vue?vue&type=style&index=2&id=7e15cb58&scoped=true&lang=css"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e15cb58"]])

export default __exports__